import { Component, Input } from '@angular/core';

import { BaseComponent, ModalService } from '../../../../tms-shared';
import { AddressService } from '../../../services';
import { AddressDetails, CustomerAddressEdit } from '../../../models';

@Component({
  selector: 'app-address-create-modal',
  templateUrl: './address-create-modal.component.html',
  styleUrl: './address-create-modal.component.scss',
})
export class AddressCreateModalComponent extends BaseComponent {
  @Input() id: string; // customerId

  constructor(
    public addressService: AddressService,
    private modalService: ModalService,
  ) {
    super();
  }

  saved(model: AddressDetails) {
    const customerAddress = { addressId: model.id, customerId: this.id } as CustomerAddressEdit;
    this.modalService.close(customerAddress);
  }
}
